import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

import { APP_STATE_TOKEN } from 'src/app/store/app/app.state.model';

@Injectable()
export abstract class BaseService {
  constructor(protected readonly store: Store) {}

  protected getLocationUrl(url?: string, locationId?: number): string {
    const defaultLocationId =
      this.store.selectSnapshot(APP_STATE_TOKEN).device?.pos_location_id;
    const locationUrl = `locations/${locationId || defaultLocationId}`;

    return `${locationUrl}${url ? '/' + url : ''}`; // Ensure the URL starts with a slash
  }
}
